var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox styled"},[_c('input',{attrs:{"id":"select-all-checkbox","type":"checkbox","name":_vm.name},domProps:{"checked":_vm.allChecked},on:{"click":_vm.onClick}}),_vm._v(" "),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('label',{attrs:{"for":"select-all-checkbox"}},[_c('span',{staticClass:"sr-only"},[_vm._v("\n      Select all\n    ")])])
}]

export { render, staticRenderFns }